import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

/** Where a company's web domain came from. */
export const CLIENT_DOMAIN_SOURCES = ['website', 'email', 'manual', 'apollo', 'import'] as const;
export type ClientDomainSource = (typeof CLIENT_DOMAIN_SOURCES)[number];

/**
 * PD-17602 — the web domains a company uses (one company can use several:
 * acme.com and acmesupply.com), so email addresses and new leads match on
 * any of them (the Mission Control mc_company_domains pattern).
 *
 * `domain` is stored normalized (normalizeWebDomain: lowercase, no scheme or
 * `www.`). A domain belongs to one live company in the tenant. That rule is
 * kept by ClientDomainsService rather than a unique index, because a removed
 * (soft-deleted) row must not block the domain from being added again, and a
 * MySQL unique index cannot ignore those rows.
 */
@Index('IDX_client_domain_domain', ['domain'], {})
@Index('IDX_client_domain_client', ['fkClientId'], {})
@Entity('client_domain')
export class ClientDomainEntity extends BaseEntity {
	@Column('int', { name: 'fk_client__id', unsigned: true })
	public fkClientId!: number;

	@Column('varchar', { name: 'domain', length: 253 })
	public domain!: string;

	/** The company's main domain (the website's); at most one per company. */
	@Column({ type: 'boolean', name: 'isPrimary', width: 1, default: () => "'0'" })
	public isPrimary!: boolean;

	@Column('varchar', { name: 'source', length: 16 })
	public source!: ClientDomainSource;
}
